import React from "react";

import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import {Button} from "reactstrap";
import ReactTable from "react-table";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import moment from "moment";
import APPCONFIG from "constants/Config";
import CollectionOverride from "components/CollectionOverride";
import EditableNotesCell from "../Parts/EditableNotesCell";
import {confirmAlert} from "react-confirm-alert";
import {Tooltip} from "@material-ui/core";


class FirearmTraceLogs extends CollectionOverride {
	constructor(props) {
		let model = new API.BuildClass(Types.Firearm_Trace_Logs._name, API.RequestType.READ_ALL);
		super(props, model);
	}

	saveNotes = async (rowId, newNotes) => {
		let logModel = new API.BuildClass(Types.Firearm_Trace_Logs._name, 'POST_NOTES');
		logModel.object.notes = newNotes;
		logModel.object.serial = this.state.data[rowId].pkey;
		await logModel.submit(null, 'POST_NOTES');
	};

	handleDeleteTrace = async (e) => {
		this.model.object.pkey = parseInt(e.currentTarget.id);
		confirmAlert({
			title: 'Confirm Delete',
			message: 'Are you sure you want to delete this Firearm Trace',
			buttons: [
				{
					label: 'Yes',
					color: 'danger',
					onClick: async () => {
						try {
							await this.model.submit(null, "DELETE");
							this.reloadTable();
						} catch (error) {
						}
						this.model.object.pkey = '';
						this.props.reloadPage();
					}
				},
				{
					label: 'No',
					onClick: () => {
					}
				}
			]
		});
	};

	render() {
		const {data, pages, limit, loading} = this.state;
		const isAdminLoggedIn = this.props.rootState.user === null;

		const columns = [
			{
				Header: "User",
				id: "user",
				accessor: obj => obj.users ? obj.users.name_first + " " + obj.users.name_last : 'Admin',
			},
			{
				Header: "Serial Number",
				id: "serial_number",
				accessor: obj => obj.serial,
			},
			{
				Header: "Date",
				id: "date",
				accessor: obj => obj.created ? moment(obj.created).local().format("MM/DD/YYYY h:mm A") : '-'
			},
			{
				Header: "Notes",
				id: "notes",
				accessor: obj => obj.notes,
				Cell: (cellInfo) => {
					const originalRow = cellInfo.original;
					const rowId = originalRow.id || cellInfo.index;

					return (
						<EditableNotesCell
							key={`notes-${rowId}`}
							rowId={rowId}
							originalValue={originalRow.notes}
							onSave={this.saveNotes}
						/>
					);
				}
			},
		];
		if (isAdminLoggedIn) {
			columns.push({
				Header: "",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 40,
				Cell: props => {
					return (
						<Tooltip title={"Delete Firearm Trace"}>
							<Button
								id={props.original.pkey}
								color="danger"
								size={"sm"}
								block={true}
								onClick={this.handleDeleteTrace}>
								<i className={"fa fa-times-circle"}/>
							</Button>
						</Tooltip>
					);
				}
			});
		}

		return (
			<Card>
				<CardContent>
					<div className="table-bar">
						<div className="d-flex">
							{this.renderSearch('Firearm Traces', "")}
							{this.renderHeaderRight("Firearm Traces", columns)}
						</div>
					</div>
					<ReactTable
						key={this.state.key}
						columns={columns}
						manual // Forces table not to paginate or sort automatically, so we can handle it server-side
						data={data}
						pages={pages} // Display the total number of pages
						loading={loading} // Display the loading overlay when we need it
						loadingText="Requesting Data"
						onFetchData={this.fetchData} // Request new data when things change
						onPageSizeChange={this.onPageSizeChange}
						onSortedChange={this.onSortedChange}
						page={this.state.page}
						onPageChange={this.onPageChange}
						expanderDefaults={{
							sortable: true,
							resizable: true,
							filterable: false,
							width: undefined
						}}
						defaultSorted={[
							{
								id: this.model.sort,
								desc: this.model.order === 'desc'
							}
						]}
						showPagination={true}
						showPaginationTop={false}
						showPaginationBottom={true}
						showPageSizeOptions={true}
						defaultPageSize={limit}
						pageSize={limit}
						pageSizeOptions={[5, 20, 50, 100, 500, 1000]}
						className="-striped -highlight"
					/>

					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
			</Card>
		)
	}
}

export default Framework.Components.withRootState(FirearmTraceLogs)